// 平台相关仓库
import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus')
    },
    monitorProjectInfo: {},
  },
  mutations: {
     SET_TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    SET_CLEAR_APP: state =>{
      Cookies.remove('sidebarStatus');
    },
    SET_MONITOR_PROJECT_INFO: (state, data) => {
      state.monitorProjectInfo = data;
    },
  },
  actions: {
    ToggleSideBar({ commit }) {
      commit('SET_TOGGLE_SIDEBAR')
    },
    ClearApp({ commit }) {
      commit('SET_CLEAR_APP')
    },
    SetMonitorProjectInfo({ commit }, params) {
      commit('SET_MONITOR_PROJECT_INFO', params);
    },
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js